export default __webpack_public_path__ + "static/media/slide_three.89588034.jpg";